import { render } from "./Numberbox.vue?vue&type=template&id=35204774&scoped=true&ts=true"
import script from "./Numberbox.vue?vue&type=script&lang=ts"
export * from "./Numberbox.vue?vue&type=script&lang=ts"

import "./Numberbox.vue?vue&type=style&index=0&id=35204774&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35204774"]])

export default __exports__